export default "/images/search.svg?baf866bb7335dc47fc4ba604059a8d48";